<script setup>
import SquareLoader from '../SquareLoader.vue';

defineProps({
  count: { type: Number, default: 1 },
  flexDirection: { type: String, default: 'row' },
});
</script>

<template>
  <div
    class="flex justify-between flex-wrap gap-6 cursor-progress"
    :style="{ flexDirection }"
  >
    <div v-for="item in count" :key="item" class="flex flex-col gap-1">
      <SquareLoader />
      <div class="text-skeleton short skeleton-loading h-2.5" />
      <div class="text-skeleton skeleton-loading h-2.5" />
      <div class="text-skeleton medium skeleton-loading h-2.5" />
    </div>
  </div>
</template>

<style>
.text-skeleton {
  width: var(--small-thumbnail-width);
}

.short {
  width: calc(var(--small-thumbnail-width) * 0.55);
}

.medium {
  width: calc(var(--small-thumbnail-width) * 0.75);
}
</style>
